import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"
import { toast } from "react-toastify";

// Create course
export const createLesson = data => post(url.CREATE_LESSON, data);
export const updateLesson = data => put(url.UPDATE_LESSON, data);
export const deleteLesson = id => del(url.DELETE_LESSON + id);
export const fetchAllLessonOfModule = data => post(url.FETCH_ALL_LESSON__OF_MODULE, data);
export const fetchSingleLesson = id => get(url.FETCH_SINGLE_LESSON + id);

